import React from 'react';
import AddPlantingModal from '../../plantings/AddPlantingModal';
import BulkBedPlacementModal from '../BulkBedPlacementModal';

interface PlanEditorModalsProps {
  saveId: string;
  farmId: string;
  selectedBedForPlanting: string | null;
  plantingModalVisible: boolean;
  onClosePlantingModal: () => void;
  onPlantingCreated?: () => Promise<void> | void;
  bulkPlacementModalVisible: boolean;
  onCloseBulkPlacementModal: () => void;
  onConfirmBulkPlacement: (params: { cropId: string; gridRows: number; gridCols: number }) => void;
  maxBoundingBox: number;
}

const PlanEditorModals: React.FC<PlanEditorModalsProps> = ({
  saveId,
  farmId,
  selectedBedForPlanting,
  plantingModalVisible,
  onClosePlantingModal,
  onPlantingCreated,
  bulkPlacementModalVisible,
  onCloseBulkPlacementModal,
  onConfirmBulkPlacement,
  maxBoundingBox,
}) => {
  return (
    <>
      {selectedBedForPlanting && (
        <AddPlantingModal
          visible={plantingModalVisible}
          bedId={selectedBedForPlanting}
          saveId={saveId}
          farmId={farmId}
          onCancel={onClosePlantingModal}
          onSuccess={onPlantingCreated}
        />
      )}

      <BulkBedPlacementModal
        saveId={saveId}
        open={bulkPlacementModalVisible}
        onClose={onCloseBulkPlacementModal}
        onConfirm={onConfirmBulkPlacement}
        maxBoundingBox={maxBoundingBox}
      />
    </>
  );
};

export default PlanEditorModals;
